import {GatewayType} from 'instruments/instrument-gateways/InstrumentGatewayConstants';
import {ValidationInfo} from 'schemas/tags/EditableSchemaTag';

export interface InstrumentAdapter {
  id: string;
  displayName: string;
  gatewayType?: GatewayType;
}

// Keep in sync with benchling_instruments_service_client.models.InstrumentTypeResourceEnablementStatus, which
// is specified in services/instruments/client/openapi.yaml -- except for special "SELECTED" state
export type InstrumentAdapterEnablement = 'ENABLED' | 'DISABLED' | 'SELECTED';
export interface InstrumentAdapterConfiguration {
  id: string;
  displayName: string;
  enablementStatus: InstrumentAdapterEnablement;
}

export interface AdapterField {
  id: string;
  displayName: string;
  info: string | null;
  isRequired: boolean;
  isUneditable?: boolean;
  defaultValue?: string;
  fieldType?: string;
}

export enum ConnectionStatus {
  PENDING = 'PENDING',
  AVAILABLE = 'AVAILABLE',
  RUNNING = 'RUNNING',
  INSTRUMENT_ERROR = 'INSTRUMENT_ERROR',
  COMMUNICATION_ERROR = 'COMMUNICATION_ERROR',
  SERVICE_UNAVAILABLE = 'SERVICE_UNAVAILABLE',
  DISABLED = 'DISABLED',
}

export enum ConnectionFieldType {
  TEXT = 'TEXT',
  SECRET_REF = 'SECRET_REF',
  PARAMETER = 'PARAMETER',
  GATEWAY = 'GATEWAY',
}

export interface ConnectionStatusResponse {
  value: ConnectionStatus;
  timestamp: string;
}

export interface InstrumentServiceDetails {
  id: string;
  adapterId: string;
  gatewayId: string;
  instrumentName: string;
  status: ConnectionStatusResponse;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  fields: {[id: string]: any};
  fieldValidationInfoByName: {[id: string]: ValidationInfo};
  allotropyVendor?: string;
  isFileSyncing?: boolean;
}

export enum InstrumentServiceLoadStatus {
  UNSET = 'UNSET',
  LOADING = 'LOADING',
  // This is the only status that should have data
  AVAILABLE = 'AVAILABLE',
  UNAVAILABLE = 'UNAVAILABLE',
}

export interface InstrumentServiceDetailsLoader {
  status: InstrumentServiceLoadStatus;
  data: InstrumentServiceDetails | null;
}
